// extracted by mini-css-extract-plugin
export default {"flashyButton":"TweetButton_flashyButton__lgKPd","animate":"TweetButton_animate__hAS95"};